<template>
  <section
    id="hero-section"
    class="hero-section">
    <div>
      <h1 class="animate-move-in-left">Hi, my name is</h1>
    </div>
    <div>
      <h2 class="big-heading animate-move-in-left">Soumyadip Hazra</h2>
    </div>
    <div>
      <h3 class="big-heading animate-move-in-left">I build things for the web.</h3>
    </div>
    <div>
      <p class="animate-move-in-right">
        I'm a software engineer based in Kolkata India, Graduate specializing in
        building (and occasionally designing) exceptional websites,
        applications, and everything in between.
      </p>
    </div>
    <div>
      <a
        href="mailto:soumyadiphazra@gmail.com"
        class="email-link animate-move-in-bottom btn-shadow-glow-background"
      >Get In Touch</a
      >
    </div>
  </section>
</template>

<script>
export default {
  name: 'Overview'
}
</script>

<style lang="scss" scoped>
</style>
